import { makeStyles, css } from '@conexasaude/hero'
import { MakeStylesProps } from './types'

const useStyles = makeStyles<MakeStylesProps>({
  modalContainer: (_theme, props) => css`
    max-width: ${props?.canReschedule ? '652px' : '532px'};
  `,

  content: () => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;

    svg {
      max-width: 170px;
      max-height: 170px;
    }
  `,

  text: () => css`
    width: 100%;
  `,

  footer: () => css`
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    gap: 16px;

    @media (max-width: 639px) {
      flex-direction: column-reverse;
      gap: 8px;

      button {
        width: 100%;
      }
    }
  `,

  actions: () => css`
    display: flex;
    gap: 16px;

    .mantine-Button-filled {
      border: none;
    }

    @media (max-width: 639px) {
      flex-direction: column-reverse;
      gap: 8px;
    }
  `,
})

export { useStyles }
